import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProgressCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={139}
    height={102}
    fill="none"
    viewBox="0 0 139 102"
    {...props}
  >
    <path
      stroke="#BFD58B"
      strokeLinecap="round"
      strokeWidth={3}
      d="M57.886 96.085a48.5 48.5 0 1 1 61.272-60.975"
    />
    <path
      stroke="#FED876"
      strokeLinecap="round"
      strokeWidth={3}
      d="M120.755 41.53a48.5 48.5 0 0 1-13.413 42.717 48.5 48.5 0 0 1-42.68 13.53"
    />
    <path fill="url(#a)" d="M0 62h139v40H0z" />
    <defs>
      <linearGradient
        id="a"
        x1={69.5}
        x2={69.5}
        y1={62}
        y2={102}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.422} stopColor="#fff" stopOpacity={0.891} />
        <stop offset={0.62} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgProgressCircle;
